import React__default from 'react';
import { useFeatureToggles } from '@grandvisionhq/state';
import { VirtualMirrorModal } from '../VirtualMirrorModal/VirtualMirrorModal.js';
import { useProductWithAFrameData } from '../../../../../context/product-context-hooks.js';
import { useVto } from '../../../context/VtoProvider.js';
import { mapGraphVariantsToVirtualMirror } from '../../mappers/mapGraphVariantsToVirtualMirror.js';
import { TryOnButton } from '../../../components/TryOnButton/TryOnButton.js';
import { useCmsData } from '../../../../../context/CmsContext.js';
import { getActiveBrandPromotion } from '../../../../../utils/get-active-brand-promotion.js';

const VirtualMirrorContainer = ({ className  })=>{
    var ref;
    const { featureConfigs  } = useFeatureToggles();
    const { activeVariant: { sku , isVtoEnabled  } , product ,  } = useProductWithAFrameData();
    const { isVtoActive , isVtoFeatureEnabled  } = useVto();
    const { brandPromotions  } = useCmsData();
    const { brandName , variants  } = product;
    const shouldShowVto = isVtoEnabled && isVtoFeatureEnabled;
    const isVirtualMirrorEnabled = shouldShowVto && (featureConfigs === null || featureConfigs === void 0 ? void 0 : featureConfigs.virtualTryOn) === 'VIRTUAL_MIRROR';
    const brandLogo = (ref = getActiveBrandPromotion(brandName, brandPromotions)) === null || ref === void 0 ? void 0 : ref.logo;
    const mappedVTOVariants = isVirtualMirrorEnabled ? mapGraphVariantsToVirtualMirror(product, variants, sku, brandLogo) : undefined;
    return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, isVtoEnabled && isVtoFeatureEnabled && /*#__PURE__*/ React__default.createElement(TryOnButton, {
        className: className
    }), isVirtualMirrorEnabled && isVtoActive && /*#__PURE__*/ React__default.createElement(VirtualMirrorModal, {
        variants: mappedVTOVariants
    }));
};

export { VirtualMirrorContainer };
//# sourceMappingURL=VirtualMirrorContainer.js.map
